import React from 'react';
import { connect } from 'react-redux';
import { actions, Form } from 'react-redux-form';
import { Col, Row } from 'react-bootstrap';
import RequiredInput from '../../../common/form/elements/required-input';
import RequiredDatePicker from '../../../common/form/elements/required-datepicker';
import ArrowButton from '../../../common/button-arrow';
import SearchableSelect from '../../../common/form/elements/searchable-select';
import { addPrize, updatePrize } from '../../../../actions/prizes';
import { getPrizeOutletIncentives } from '../../../../actions/prizes';
import { validators } from '../../../../utils/validators';

const PrizeForm = ({
  dispatch,
  outlets,
  incentives,
  formData,
  formValid,
  incentiveId,
  outletId,
  prize
}) => {
  const onSubmit = payload => {
    if (prize.id) {
      dispatch(updatePrize(prize.id, payload));
    } else {
      dispatch(addPrize(payload));
    }
  };

  const onOutletSelect = outlet_id => {
    dispatch(getPrizeOutletIncentives(outlet_id)).then(() => {
      dispatch(actions.reset('deep.prize.incentive_id'));
      dispatch(actions.setValidity('deep.prize.incentive_id', false));
    });
  };
  return (
    <Form model="deep.prize" onSubmit={onSubmit}>
      <Row>
        <Col md={10}>
          <SearchableSelect
            label="Outlet"
            model="deep.prize.outlet_id"
            options={outlets.map(outlet => ({
              label: `${outlet.customer_number} - ${outlet.name}`,
              value: outlet.id
            }))}
            value={outletId}
            required
            onChange={onOutletSelect}
          />
        </Col>
      </Row>
      {formData.outlet_id && (
        <Row>
          <Col md={10}>
            <SearchableSelect
              label="Incentive"
              model="deep.prize.incentive_id"
              options={incentives.map(incentive => ({
                label: incentive.name,
                value: incentive.id
              }))}
              value={incentiveId}
              required
            />
          </Col>
        </Row>
      )}
      <Row>
        <Col md={10}>
          <RequiredInput label="Prize Name" model=".name" />
        </Col>
      </Row>
      <Row>
        <Col md={10}>
          <RequiredInput label="Prize Description" model=".description" />
        </Col>
      </Row>
      <Row>
        <Col md={10}>
          <RequiredInput
            label="Prize Value (€)"
            model=".value"
            inputType="number"
            min="0"
            step="1"
            validations={{
              minValue: validators.minValue(0, null, 'error'),
              isInteger: validators.valueIsInteger()
            }}
            messages={{
              minValue: 'Must be greater than 0',
              isInteger: 'Must be an integer'
            }}
          />
        </Col>
      </Row>
      <Row>
        <Col md={10}>
          <RequiredDatePicker
            label="Prize Award Date"
            model="deep.prize.award_date"
            value={formData.award_date}
          />
        </Col>
      </Row>
      <Row>
        <Col lg={10}>
          <ArrowButton color="red" className="pull-right" disabled={!formValid}>
            Save
          </ArrowButton>
        </Col>
      </Row>
    </Form>
  );
};

const mapStateToProps = state => {
  return {
    prize: state.prizes.prize || {},
    formData: state.deep.prize,
    incentiveId: state.deep.prize.incentive_id || '',
    outletId: state.deep.prize.outlet_id || '',
    formValid: state.deep.forms.prize.$form.valid,
    incentives: state.prizes.outlet_incentives || [],
    outlets: state.prizes.meta.outlets || []
  };
};

export default connect(mapStateToProps)(PrizeForm);



// WEBPACK FOOTER //
// ./src/components/admin/prizes/edit/prize-form.js